import { axiosGet } from './axiosService';

const loansURL = '/Loans';

export class LoanService {
	getVirtualIban(loanId) {
		return axiosGet(null, `${loansURL}/${loanId}/virtual-iban`);
	}
}
